import script from "./PatientDatatableReportPopulatedForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientDatatableReportPopulatedForm.vue?vue&type=script&setup=true&lang=js"

import "./PatientDatatableReportPopulatedForm.vue?vue&type=style&index=0&id=725df652&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-725df652"]])

export default __exports__